import React from 'react';
import { connect } from "react-redux";

class SportIcon extends React.Component {
	render() {
		const { feedId, sportId, className, sportTypesIcons } = this.props;
		const img = sportTypesIcons && sportTypesIcons.filter((item) => {
			return item.sportTypesIconsID == sportId && item.feedId == feedId;
		});

		let icon = img && img[0] ? img[0].sportTypesIconsName : ''; 

		return (
			<div className={className || 'icon'}><img src={icon} alt="sport-icon" /></div>
		)
	}
}
const mapStateToProps = (state, props) => {
	return {
		sportTypesIcons: state.general.sportTypesIcons
	};
};

const mapDispatchToProps = (dispatch) => ({

});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SportIcon);